// Module
var code = "<div> <div view=\"Repeat\" data-items=\"[[columns]]\" data-as=\"column\" class=\"mt-16 md:flex md:space-x-6\"> <div view=\"[[ column ]]\" data=\"[[ column]]\" class=\"flex-[[column.width]]\"></div> </div> </div> ";
// Exports
export default code;